const FILTER = currency => ({
  type: 'FILTER',
  payload: currency,
});

export default FILTER;
